module.exports = require('./dist');



//////////////////
// WEBPACK FOOTER
// ./~/react-google-invisible-recaptcha/index.js
// module id = 643
// module chunks = 96961042003272